import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center">
            平台优势
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            为什么选择木瓜影视？五大核心优势告诉你答案
          </p>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {featuresData.map((item) => (
              <div
                key={item.id}
                className="group text-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-default"
              >
                <span className="inline-flex w-14 h-14 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-900 font-heading">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}